export default __webpack_public_path__ + "static/media/Share-blue.ea572473.svg";